import React from 'react';
import ExternalRedirect from './ExternalRedirect';

const App = () => {
  return (
    <div>
      <ExternalRedirect to="https://t.me/GolfinCriptoBot" />
    </div>
  );
};

export default App;
